import { GlobalPerformanceTrendChart, Text } from '@viapeople/components'
import type { AggregationStore } from '../stores/aggregationStore'
import { OverallDistributionSection } from './OverallDistributionSection'
import { useRatingScaleMax } from './useRatingScaleMax'

type TrendPoint = NonNullable<AggregationStore['summary']>['performanceTrend'][number]

export function GlobalPerformanceSection({ trend }: { trend: TrendPoint[] }) {
	const scaleMax = useRatingScaleMax()
	return (
		<div className='rounded-lg border border-neutral-200 bg-white p-6 flex flex-col gap-6 text-left'>
			<Text variant='large' weight='semibold'>
				Global Performance
			</Text>
			<GlobalPerformanceTrendChart trend={trend} scaleMax={scaleMax} />
			<OverallDistributionSection />
		</div>
	)
}
